import { n as _getArrayProp } from "./helpers-bwfx1e-Y.js";
import { t as getTheme_v2 } from "./getTheme_v2-y09KqtEb.js";
import { _ as useTheme_v2, h as _cardColorStyle, m as focusRingStyle, p as focusRingBorderStyle, v as responsiveRadiusStyle, y as Box } from "./useLayer-BAVfmbNN.js";
import { t as Flex } from "./flex-C-5JHi1C.js";
import { n as Text } from "./stack-C2HKTF-l.js";
import { c } from "react/compiler-runtime";
import { SpinnerIcon } from "@sanity/icons/Spinner";
import { isValidElement } from "react";
import { css, styled } from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
import { isValidElementType } from "react-is";
var spinnerIcon = "_1b6o2se1";
/**
* Indicate that something is loading for an indeterminate amount of time.
*
* @public
*/
function Spinner(props) {
	let $ = c(3), t0;
	$[0] === Symbol.for("react.memo_cache_sentinel") ? (t0 = /* @__PURE__ */ jsx(SpinnerIcon, { className: spinnerIcon }), $[0] = t0) : t0 = $[0];
	let t1;
	return $[1] === props ? t1 = $[2] : (t1 = /* @__PURE__ */ jsx(Text, {
		"data-ui": "Spinner",
		...props,
		children: t0
	}), $[1] = props, $[2] = t1), t1;
}
/**
* @internal
*/
function buttonBaseStyles(props) {
	let { $width } = props, { style } = getTheme_v2(props.theme);
	return css`${style?.button};-webkit-font-smoothing:inherit;appearance:none;display:inline-flex;align-items:center;font:inherit;border:0;outline:none;user-select:none;text-decoration:none;border:0;box-sizing:border-box;padding:0;margin:0;white-space:nowrap;text-align:left;position:relative;vertical-align:top;${$width === "fill" && css`width:-moz-available;width:-webkit-fill-available;width:stretch;`} & > span{display:block;flex:1;min-width:0;border-radius:inherit;}&::-moz-focus-inner{border:0;padding:0;}`;
}
function combineBoxShadow(...boxShadows) {
	return boxShadows.filter(Boolean).join(",");
}
/**
* @internal
*/
function buttonColorStyles(props) {
	let { $mode } = props, { button, color: baseColor, style } = getTheme_v2(props.theme);
	props.$mode;
	let mode = baseColor.button[$mode] || baseColor.button.default, color = mode[props.$tone] || mode.default, border = {
		width: button.border.width,
		color: "var(--card-border-color)"
	};
	return [
		_cardColorStyle(baseColor, color.enabled),
		{
			backgroundColor: "var(--card-bg-color)",
			color: "var(--card-fg-color)",
			boxShadow: focusRingBorderStyle(border),
			"&:disabled, &[data-disabled=\"true\"]": _cardColorStyle(baseColor, color.disabled),
			"&:not([data-disabled='true'])": {
				boxShadow: combineBoxShadow(focusRingBorderStyle(border), void 0),
				"&:focus": { boxShadow: focusRingStyle({
					base: baseColor,
					border: {
						width: 2,
						color: baseColor.bg
					},
					focusRing: button.focusRing
				}) },
				"&:focus:not(:focus-visible)": { boxShadow: combineBoxShadow(focusRingBorderStyle(border), void 0) },
				"@media (hover: hover)": {
					"&:hover": _cardColorStyle(baseColor, color.hovered),
					"&:active": _cardColorStyle(baseColor, color.pressed),
					"&[data-hovered]": _cardColorStyle(baseColor, color.hovered)
				},
				"&[data-selected]": _cardColorStyle(baseColor, color.pressed)
			}
		},
		style?.button?.root
	].filter(Boolean);
}
const StyledButton = /* @__PURE__ */ styled.button.withConfig({
	displayName: "StyledButton",
	componentId: "sc-qd71yy-0"
})(responsiveRadiusStyle, buttonBaseStyles, buttonColorStyles), LoadingBox = styled.div.withConfig({
	displayName: "LoadingBox",
	componentId: "sc-qd71yy-1"
})`position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;background-color:var(--card-bg-color);border-radius:inherit;z-index:1;box-shadow:inherit;`;
function ButtonComponent(props) {
	let $ = c(87), IconComponent, IconRightComponent, children, disabled, loading, paddingBottomProp, paddingLeftProp, paddingRightProp, paddingTopProp, paddingXProp, paddingYProp, ref, restProps, selected, t0, t1, t2, t3, t4, t5, t6, t7, t8, text, textAlign, textWeight, width;
	$[0] === props ? (IconComponent = $[1], IconRightComponent = $[2], children = $[3], disabled = $[4], loading = $[5], paddingBottomProp = $[6], paddingLeftProp = $[7], paddingRightProp = $[8], paddingTopProp = $[9], paddingXProp = $[10], paddingYProp = $[11], ref = $[12], restProps = $[13], selected = $[14], t0 = $[15], t1 = $[16], t2 = $[17], t3 = $[18], t4 = $[19], t5 = $[20], t6 = $[21], t7 = $[22], t8 = $[23], text = $[24], textAlign = $[25], textWeight = $[26], width = $[27]) : ({children, disabled, ref, fontSize: t0, icon: IconComponent, iconRight: IconRightComponent, justify: t1, loading, mode: t2, padding: t3, paddingX: paddingXProp, paddingY: paddingYProp, paddingTop: paddingTopProp, paddingBottom: paddingBottomProp, paddingLeft: paddingLeftProp, paddingRight: paddingRightProp, radius: t4, selected, gap: t5, text, textAlign, textWeight, tone: t6, type: t7, muted: t8, width, ...restProps} = props, $[0] = props, $[1] = IconComponent, $[2] = IconRightComponent, $[3] = children, $[4] = disabled, $[5] = loading, $[6] = paddingBottomProp, $[7] = paddingLeftProp, $[8] = paddingRightProp, $[9] = paddingTopProp, $[10] = paddingXProp, $[11] = paddingYProp, $[12] = ref, $[13] = restProps, $[14] = selected, $[15] = t0, $[16] = t1, $[17] = t2, $[18] = t3, $[19] = t4, $[20] = t5, $[21] = t6, $[22] = t7, $[23] = t8, $[24] = text, $[25] = textAlign, $[26] = textWeight, $[27] = width);
	let fontSize = t0 === void 0 ? 1 : t0, justifyProp = t1 === void 0 ? "center" : t1, mode = t2 === void 0 ? "default" : t2, paddingProp = t3 === void 0 ? 3 : t3, radiusProp = t4 === void 0 ? 2 : t4, gap = t5 === void 0 ? 3 : t5, tone = t6 === void 0 ? "default" : t6, type = t7 === void 0 ? "button" : t7, muted = t8 !== void 0 && t8, { button } = useTheme_v2(), t9;
	$[28] === justifyProp ? t9 = $[29] : (t9 = _getArrayProp(justifyProp), $[28] = justifyProp, $[29] = t9);
	let justify = t9, t10;
	$[30] === paddingProp ? t10 = $[31] : (t10 = _getArrayProp(paddingProp), $[30] = paddingProp, $[31] = t10);
	let padding = t10, t11;
	$[32] === paddingXProp ? t11 = $[33] : (t11 = _getArrayProp(paddingXProp), $[32] = paddingXProp, $[33] = t11);
	let paddingX = t11, t12;
	$[34] === paddingYProp ? t12 = $[35] : (t12 = _getArrayProp(paddingYProp), $[34] = paddingYProp, $[35] = t12);
	let paddingY = t12, t13;
	$[36] === paddingTopProp ? t13 = $[37] : (t13 = _getArrayProp(paddingTopProp), $[36] = paddingTopProp, $[37] = t13);
	let paddingTop = t13, t14;
	$[38] === paddingBottomProp ? t14 = $[39] : (t14 = _getArrayProp(paddingBottomProp), $[38] = paddingBottomProp, $[39] = t14);
	let paddingBottom = t14, t15;
	$[40] === paddingLeftProp ? t15 = $[41] : (t15 = _getArrayProp(paddingLeftProp), $[40] = paddingLeftProp, $[41] = t15);
	let paddingLeft = t15, t16;
	$[42] === paddingRightProp ? t16 = $[43] : (t16 = _getArrayProp(paddingRightProp), $[42] = paddingRightProp, $[43] = t16);
	let paddingRight = t16, t17;
	$[44] === radiusProp ? t17 = $[45] : (t17 = _getArrayProp(radiusProp), $[44] = radiusProp, $[45] = t17);
	let radius = t17, t18;
	$[46] === gap ? t18 = $[47] : (t18 = _getArrayProp(gap), $[46] = gap, $[47] = t18);
	let spacing = t18, t19;
	$[48] !== padding || $[49] !== paddingBottom || $[50] !== paddingLeft || $[51] !== paddingRight || $[52] !== paddingTop || $[53] !== paddingX || $[54] !== paddingY ? (t19 = {
		padding,
		paddingX,
		paddingY,
		paddingTop,
		paddingBottom,
		paddingLeft,
		paddingRight
	}, $[48] = padding, $[49] = paddingBottom, $[50] = paddingLeft, $[51] = paddingRight, $[52] = paddingTop, $[53] = paddingX, $[54] = paddingY, $[55] = t19) : t19 = $[55];
	let boxProps = t19, t20 = !!(loading || disabled), t21 = selected ? "" : void 0, t22 = !!(loading || disabled), t23;
	$[56] === loading ? t23 = $[57] : (t23 = !!loading && /* @__PURE__ */ jsx(LoadingBox, { children: /* @__PURE__ */ jsx(Spinner, {}) }), $[56] = loading, $[57] = t23);
	let t24;
	$[58] !== IconComponent || $[59] !== IconRightComponent || $[60] !== boxProps || $[61] !== button || $[62] !== fontSize || $[63] !== justify || $[64] !== muted || $[65] !== spacing || $[66] !== text || $[67] !== textAlign || $[68] !== textWeight ? (t24 = (IconComponent || text || IconRightComponent) && /* @__PURE__ */ jsx(Box, {
		as: "span",
		...boxProps,
		children: /* @__PURE__ */ jsxs(Flex, {
			as: "span",
			justify,
			gap: spacing,
			children: [
				IconComponent && /* @__PURE__ */ jsxs(Text, {
					size: fontSize,
					children: [isValidElement(IconComponent) && IconComponent, isValidElementType(IconComponent) && /* @__PURE__ */ jsx(IconComponent, {})]
				}),
				text && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(Text, {
					muted,
					align: textAlign,
					size: fontSize,
					textOverflow: "ellipsis",
					weight: textWeight ?? button.textWeight,
					children: text
				}) }),
				IconRightComponent && /* @__PURE__ */ jsxs(Text, {
					size: fontSize,
					children: [isValidElement(IconRightComponent) && IconRightComponent, isValidElementType(IconRightComponent) && /* @__PURE__ */ jsx(IconRightComponent, {})]
				})
			]
		})
	}), $[58] = IconComponent, $[59] = IconRightComponent, $[60] = boxProps, $[61] = button, $[62] = fontSize, $[63] = justify, $[64] = muted, $[65] = spacing, $[66] = text, $[67] = textAlign, $[68] = textWeight, $[69] = t24) : t24 = $[69];
	let t25;
	$[70] !== boxProps || $[71] !== children ? (t25 = children && /* @__PURE__ */ jsx(Box, {
		as: "span",
		...boxProps,
		children
	}), $[70] = boxProps, $[71] = children, $[72] = t25) : t25 = $[72];
	let t26;
	return $[73] !== mode || $[74] !== radius || $[75] !== ref || $[76] !== restProps || $[77] !== t20 || $[78] !== t21 || $[79] !== t22 || $[80] !== t23 || $[81] !== t24 || $[82] !== t25 || $[83] !== tone || $[84] !== type || $[85] !== width ? (t26 = /* @__PURE__ */ jsxs(StyledButton, {
		"data-ui": "Button",
		...restProps,
		$mode: mode,
		$radius: radius,
		$tone: tone,
		"data-disabled": t20,
		"data-selected": t21,
		disabled: t22,
		ref,
		type,
		$width: width,
		children: [
			t23,
			t24,
			t25
		]
	}), $[73] = mode, $[74] = radius, $[75] = ref, $[76] = restProps, $[77] = t20, $[78] = t21, $[79] = t22, $[80] = t23, $[81] = t24, $[82] = t25, $[83] = tone, $[84] = type, $[85] = width, $[86] = t26) : t26 = $[86], t26;
}
/**
* @public
*/
const Button = ButtonComponent;
export { Spinner as n, spinnerIcon as r, Button as t };

//# sourceMappingURL=button-D6Z-yLlP.js.map